<template>
  <div class="main-content-container container-fluid px-4" style="margin-top:-55px">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Category Add</h3>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Category Add</h6>

        <router-link :to="{ name: 'Category-Dashboard'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form>
                <d-form-row>

                  <d-col md="5" class="form-group row">
                    <label class="col-md-5 col-form-label">Name</label>
                    <div class="col-md-7">
                      <input
                        type="text" 
                        class="form-control required-field"
                        v-model="CategoryMaster.DataModel.Data.Name"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>

                  <d-col md="5" class="form-group row" style="margin-left:20px">
                  </d-col>
                  <d-col md="5" class="form-group row">
                    <label class="col-md-5 col-form-label">Description</label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control required-field"
                        v-model="CategoryMaster.DataModel.Data.Description"
                        autocomplete="off"
                      />
                    </div>
                  </d-col>
                  
                </d-form-row>

           

                <div class style="text-align:center">
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="SubmitCategoryMaster"
                    style="margin-right:10px"
                  >Submit</d-button>
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="ClearCategoryMaster"
                  >Cancel</d-button>
                </div>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
  import Utilities from "@/Utilities/Utilities";
  import axios from "axios";
// import VueToast from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-default.css";
// Vue.use(VueToast);

export default {
  name: "CategoryMaster",
  data() {
    return {
      CategoryMaster: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            // User: {
            Id: 0,
            Name: null,
            Description: null
          },
          UIData: {},
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0,
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0,
          },
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "", // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],
        Masters: {
          CategoryMasterList: [],
        },
        Modal: {},
        CharRestrict: {},
      },
    };
  },
  mounted() {
    this.ListCategoryMaster();
  },
  methods: {
    Select() {
      console.log(this.CategoryMaster.DataModel.Data);
    },

    SubmitCategoryMaster() {
      let vm = this;
      
      this.CategoryMaster.DataModel.Data.InvestorId = 1;
      this.CategoryMaster.DataModel.Data.CRUD = "Create";

      var dataString = JSON.stringify(this.CategoryMaster.DataModel.Data);

      axios
        .post(
          "APIScript/PHP/APIService/CategoryMaster/CategoryMasterService.php",
          dataString
        )
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.$toaster.success("Save Successfully.");
            Utilities.gotoRoute(vm, "/user-setup");
            console.log(response.data);
          } else {
            if (
              !Utilities.IsNotNullOrEmptyOrUndefined(
                vm.CategoryMaster.DataModel.Data.Username
              ) ||
              !Utilities.IsNotNullOrEmptyOrUndefined(
                vm.CategoryMaster.DataModel.Data.Password
              )
            ) {
              console.log(response.data.ErrorInfo);
              vm.$swal.fire(
                "Information missing",
                "Please provid Mobile No, Date and Amount ",
                "error"
              );
            } else {
              console.log(response.data.ErrorInfo);
              vm.$swal.fire(
                "Oops...",
                "Incorrect Mobile No, Date or Amount !",
                "error"
              );
            }
          }
        })
        .catch(function (response) {
          console.log(response);
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
     
    },

    ClearCategoryMaster() {
      (this.CategoryMaster.DataModel.Data.Username = null),
        (this.CategoryMaster.DataModel.Data.Password = null),
        (this.CategoryMaster.DataModel.Data.ConfirmPassword = null);
    },

    ListCategoryMaster() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.CategoryMaster.DataModel.Data.Token = Token;
      this.CategoryMaster.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.CategoryMaster.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/CategoryMaster/CategoryMasterService.php",
          dataString
        )
        .then(function (response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.CategoryMaster.Masters.CategoryMasterList = response.data.Result;
            console.log(vm.CategoryMaster.Masters.CategoryMasterList);
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function (response) {
          console.log(response.data.ErrorInfo);
        });
    },
    SelectMobileNumber() {
      Object.entries(this.CategoryMaster.Masters.CategoryMasterList).forEach(
        ([key, val]) => {
          if (val.ContactNumber == this.CategoryMaster.DataModel.Data.Username) {
            this.CategoryMaster.DataModel.Data.Username = val;
          }

          this.CategoryMaster.DataModel.Data.Username = Utilities.selectFromList(
            this.CategoryMaster.DataModel.Data.Username,
            this.CategoryMaster.Masters.CategoryMasterList,
            "ContactNumber"
          );
        }
      );
    },
  },
};
</script>
